import {
  COLUMN_WIDTHS,
  DEFAULT_CSV_FILE_HEADERS,
  EXPECTED_COLUMNS,
  FILE_CSV_SIZE_BYTE_LIMIT,
  IMPORT_ADDRESSES_SUCCESS_ALERT,
  MAP_COLUMNS_ALERT,
  PREPARING_CSV_ALERT,
  REPAIR_ADDRESSES_ALERT,
  REPAIR_ADDRESSES_NO_RESULTS_ALERT,
  REPAIR_ADDRESSES_NO_ROWS_FOUND_ALERT,
  REPAIR_ADDRESSES_SUCCESS_ALERT,
  REQUIRED_AMOUNT_OF_COLUMNS,
  UploadCsvModalSteps,
} from '../../../constants/addressBook';
import { ICsvUploadProfile } from './csvUploadProfile';

export const addressBookCsvProfile: ICsvUploadProfile = {
  columns: EXPECTED_COLUMNS,
  columnWidths: COLUMN_WIDTHS,
  fileHeaders: DEFAULT_CSV_FILE_HEADERS,
  requiredColumnCount: REQUIRED_AMOUNT_OF_COLUMNS,
  fileSizeByteLimit: FILE_CSV_SIZE_BYTE_LIMIT,
  steps: UploadCsvModalSteps,
  copy: {
    preparingCsvAlert: PREPARING_CSV_ALERT,
    mapColumnsAlert: MAP_COLUMNS_ALERT,
    importSuccessAlert: IMPORT_ADDRESSES_SUCCESS_ALERT,
    repairAlert: REPAIR_ADDRESSES_ALERT,
    repairSuccessAlert: REPAIR_ADDRESSES_SUCCESS_ALERT,
    noResultsAlert: REPAIR_ADDRESSES_NO_RESULTS_ALERT,
    noRowsFoundAlert: REPAIR_ADDRESSES_NO_ROWS_FOUND_ALERT,
  },
};
